module.exports = __webpack_public_path__ + "dj.0b3d1b91acfb60404200.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/dj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/dj.svg
// module chunks = styles